<template>
  <div class="appointment-records column">
    <div class="row flex-center topLabel">
      <div
        class="typeLabel P-Cursor"
        :class="missedAppoint ? 'active' : ''"
        @click="tabSwitch('missedAppoint')"
      >
        <i class="iconfont icon-success"></i> 包含失约
      </div>
      <div
        class="typeLabel P-Cursor"
        :class="cancel ? 'active' : ''"
        @click="tabSwitch('cancel')"
      >
        <i class="iconfont icon-success"></i> 包含取消
      </div>
      <!-- <div class="flex-1"></div>
      <el-button type="primary" size="small" plain @click="goToCreate">
        新增预约
      </el-button> -->
    </div>

    <div v-if="list.length > 0" class="flex-1 overflow-y appointment-list">
      <div class="appointItem" v-for="(row, index) in list" :key="index">
        <div class="toptitle row flex-center">
          <div class="flex-1 row flex-center top-main">
            <div class="visit-time">{{ formatVisitDateTime(row) }}</div>
            <div class="typeTag" :style="tagColor(row)">{{ row.statusStr }}</div>
          </div>
        </div>
 
      <div class="info">
        <!-- 咨询师与护士都有值：医生单独一行，咨询师与护士同一行 -->
        <template v-if="row.consultantName && row.nurseName">
          <div class="infoitem row" v-if="row.doctorName">
            <div class="left">预约医生:</div>
            <div class="flex-1 righttext">{{ row.doctorName }}</div>
          </div>
          <div class="infoitem row flex-center two-col">
            <div class="col row">
              <div class="left">咨询师:</div>
              <div class="flex-1 righttext">{{ row.consultantName }}</div>
            </div>
            <div class="col row">
              <div class="left">护士:</div>
              <div class="flex-1 righttext">{{ row.nurseName }}</div>
            </div>
          </div>
        </template>
        <!-- 否则：医生与咨询师、护士中「至多一个有值的」同一行 -->
        <div
          v-else-if="row.doctorName || row.consultantName || row.nurseName"
          class="infoitem row flex-center two-col"
        >
          <div class="col row" v-if="row.doctorName">
            <div class="left">预约医生:</div>
            <div class="flex-1 righttext">{{ row.doctorName }}</div>
          </div>
          <div class="col row" v-if="row.consultantName">
            <div class="left">咨询师:</div>
            <div class="flex-1 righttext">{{ row.consultantName }}</div>
          </div>
          <div class="col row" v-if="row.nurseName">
            <div class="left">护士:</div>
            <div class="flex-1 righttext">{{ row.nurseName }}</div>
          </div>
        </div>

        <div class="infoitem row" v-if="row.itemNames">
          <div class="left">预约项目:</div>
          <div class="flex-1 righttext">{{ row.itemNames }}</div>
        </div>

        <div class="infoitem row" v-if="row.remark">
          <div class="left">预约备注:</div>
          <div class="flex-1 righttext">{{ row.remark }}</div>
        </div>
        <div class="infoitem row" v-if="row.appointSource">
          <div class="left">就诊来源:</div>
          <div class="flex-1 righttext">{{ row.appointSource }}</div>
        </div>
        <div class="infoitem row" v-if="row.clinicName">
          <div class="left">预约门店:</div>
          <div class="flex-1 righttext">{{ row.clinicName }}</div>
        </div>
        <div class="time">
          {{ row.createEmployeeName }} 创建于 {{ row.createTime }}
        </div>

        <div class="row mt8">
          <div class="flex-1"></div>
          <el-button
            v-if="isAppointmentConfirmable(row)"
            type="primary"
            size="small"
            plain
            @click="confirmAppointment(row)"
          >
            确认
          </el-button>
          <el-button
           v-if="isAppointmentRescheduleable(row)"
            type="primary"
            size="small"
            plain
            @click="goToReschedule(row)"
          >
            改约
          </el-button>
          <el-button
            v-if="isAppointmentEditable(row)"
            type="primary"
            size="small"
            plain
            @click="goToEdit(row)"
          >
            修改
          </el-button>
          <el-button
            v-if="isAppointmentCancelable(row)"
            type="primary"
            size="small"
            plain
            @click="goToCancel(row)"
          >
            取消
          </el-button>
        </div>
      </div>
      </div>
    </div>

    <div v-else class="flex-1 overflow-hidden">
      <EmptyImgh5></EmptyImgh5>
    </div>

    <!-- 预约记录下方：新增预约按钮（对齐 todayTodo 的新增入口） -->
    <div class="toCreateBtnWrap">
      <div class="toCreateBtn" @click="goToCreate">新建预约</div>
    </div>
  </div>
</template>

<script>
import { userStore } from "@/store/user.js";
import {
  diagnosisListAll,
  getcolors,
  confirmAppointmentApi,
  getWecomAppointmentDetail,
} from "@/api/patient.js";
import { loadingStore } from "@/store/loading.js";
import { createAppointmentStore } from "@/store/h5/createAppointment.js";
import { showToast } from "vant";


/***
{
  "0": "没状态（兜底）",
  "1": "待定",
  "2": "预约",
  "3": "已确认",
  "4": "已到达",
  "5": "挂号",
  "6": "咨询中",
  "7": "治疗中",
  "8": "治疗完成",
  "9": "已结账",
  "10": "已离开",
  "11": "已取消",
  "12": "已失约"
}
*/

// 可修改：1待定 2预约 3已确认 4已到达
const EDITABLE_APPOINT_STATUS = [1, 2, 3, 4];
// 可确认：1待定 2预约
const CONFIRMABLE_APPOINT_STATUS = [1, 2];
// 可取消：1待定 2预约 3已确认 4已到达
const CANCELABLE_APPOINT_STATUS = [1, 2, 3, 4];
// 可改约：1待定 2预约 3已确认
const RESCHEDULEABLE_APPOINT_STATUS = [1, 2, 3];

// 新建预约页路由名
const CREATE_APPOINT_ROUTE_NAME = "personalCenterCreateAppoint";
/** 路由 query：标识进入改约模式 */
const RESCHEDULE_QUERY_FLAG = "1";

export default {
  name: "appointmentRecords",
  props: {},
  data: function () {
    return {
      base: {},
      cancel: false,
      missedAppoint: false,
      list: [],
      apptColors: [],
    };
  },
  setup() {
    let loading = loadingStore();
    return {
      loading,
    };
  },

  mounted: function () {
    let that = this;
    that.getList();
    that.getColor();
  },
  methods: {
    getList() {
      let that = this;
      const aloginStoreuth = userStore();

      let reqData = {
        cancel: that.cancel,
        missedAppoint: that.missedAppoint,
        followup: false,
        offline: false,
        onLine: false,
        cusId: aloginStoreuth.cusId,
        corpId: aloginStoreuth.corpId,
        seeDoctor: true,
        undetermined: true,
      };
      that.loading.showLoading();
      diagnosisListAll(reqData).then((res) => {
        that.loading.hideLoading();
        that.list = res.data.data.flatMap((item) => item.appointList);
      });
    },
    getColor() {
      let that = this;
      getcolors().then((res) => {
        let { apptColors } = res.data.data;
        that.apptColors = apptColors;
      });
    },
    tagColor(row) {
      let that = this;
      let { apptColors } = that;
      for (let i = 0; i < apptColors.length; i++) {
        if (apptColors[i].statusName === row.statusStr) {
          return {
            backgroundColor: `#${apptColors[i].color}`,
            color: "#fff",
          };
        }
      }
      //如果 row.statusStr == apptColors下对象的 statusName 则返回这个对象的 color
    },
    tabSwitch(name) {
      this[name] = !this[name];
      this.getList();
    },
    formatVisitDateTime(row) {
      const date = row.visitDate || "";
      const start = row.startTime || "";
      const end = row.endTime || "";
      if (!date && !start && !end) return "";
      return `${date} ${start}${start || end ? "-" : ""}${end}`.trim();
    },
    // 是否有确认按钮
    isAppointmentConfirmable(row) {
      return CONFIRMABLE_APPOINT_STATUS.includes(Number(row.status));
    },
    // 是否有改约按钮
    isAppointmentRescheduleable(row) {
      return RESCHEDULEABLE_APPOINT_STATUS.includes(Number(row.status));
    },
    // 是否有修改按钮
    isAppointmentEditable(row) {
      return EDITABLE_APPOINT_STATUS.includes(Number(row.status));
    },
    // 是否有取消按钮
    isAppointmentCancelable(row) {
      return CANCELABLE_APPOINT_STATUS.includes(Number(row.status));
    },
    // 确认预约
    confirmAppointment(row) {
      const statusCode = Number(row.status);
      if (statusCode === 1) {
        // 待定预约的确认还是进入编辑页面
        this.goToEdit(row, true);
      }
      if (statusCode === 2) {
        // 预约状态的确认直接调接口
        confirmAppointmentApi(row.id).then(() => {
          showToast("确认成功");
          this.getList();
        });
      }
    },
    //编辑
    goToEdit(row, isConfirm = false) {
      if (!row.id) return;

      this.$router.push({
        name: "personalCenterAppointmentForm",
        query: { appointId: String(row.id), isConfirm },
      });
    },
    goToCreate() {
      this.$router.push({ name: CREATE_APPOINT_ROUTE_NAME });
    },
    /** 取消预约：进入填写取消原因页 */
    goToCancel(row) {
      if (!row.id) return;
      this.$router.push({
        name: "cancelAppointmentForm",
        query: { appointId: String(row.id) },
      });
    },
    /** 改约：拉取预约详情写入 store，跳转新建预约页（改约模式） */
    goToReschedule(row) {
      if (!row?.id) return;

      const appointId = String(row.id);
      this.loading.showLoading();
      getWecomAppointmentDetail(appointId)
        .then((res) => {
          const detailData = res?.data?.data;
          if (!detailData?.id) {
            showToast("获取预约信息失败");
            return;
          }
          const createAppointment = createAppointmentStore();
          createAppointment.setRescheduleAppointmentInfo(detailData);
          this.$router.push({
            name: CREATE_APPOINT_ROUTE_NAME,
            query: { isReschedule: RESCHEDULE_QUERY_FLAG },
          });
        })
        .catch(() => {
          showToast("获取预约信息失败");
        })
        .finally(() => {
          this.loading.hideLoading();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.appointment-records {
 
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;

  .topLabel {
    margin-bottom: 0.25rem;
    text-align: left;
    flex-wrap: wrap;
    gap: 0.167rem 0;

    .typeLabel {
      padding: 0.083rem 0.167rem;
      color: #5a7b7d;
      background-color: #e6f4f5;
      border: 1px solid #e6f4f5;
      font-size: 0.292rem;
      border-radius: 999px;
      margin-right: 0.167rem;

      .icon-success {
        display: none;
      }

      &.active {
        background-color: #eaf8f9;
        color: rgb(40, 184, 195);
        border: 1px solid rgb(40, 184, 195);

        .icon-success {
          display: inline;
        }
      }
    }
  }

  .appointItem {
    border: 1px solid #e6e6e6;
    border-radius: 0.083rem;
    margin-bottom: 0.208rem;
    text-align: left;

    .time {
      margin-top: 0.25rem;
      font-size: 0.25rem;
      color: #666;
    }

    .toptitle {
      text-align: left;
      font-size: 0.292rem;
      padding: 0.167rem 0.313rem;
      border-bottom: 1px solid #ededed;
      background: #f7f7f7;
      .top-main {
        min-width: 0;
        justify-content: space-between;
      }
      .visit-time {
        font-size: 0.292rem;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .icon-sanjiao {
        color: #999999;
        margin-right: 0.104rem;
      }

      .typeTag {
        margin-left: 0.167rem;
        font-size: 0.25rem;
        color: #333;
        background-color: #fadb14;
        padding: 0.083rem 0.125rem;
        border-radius: 0.042rem;
        flex-shrink: 0;
      }
    }

    .info {
      background-color: #fff;
      padding: 0.25rem;

      .infoitem {
        font-size: 0.292rem;
        text-align: left;
        margin-bottom: 0.083rem;
        align-items: center;
        line-height: 1.5;

        &.two-col {
          .col {
            width: 50%;
            min-width: 0;
            align-items: flex-start;
          }
          .col:only-child {
            width: 100%;
          }
        }

        .left {
          color: #666;
          flex-shrink: 0;
          text-align: left;
          margin-right: 0.167rem;
        }

        .righttext {
          font-size: 0.292rem;
          color: #333;
          min-width: 0;
          word-break: break-all;
        }
      }
    }
  }

  .appointment-list {
    padding: 0 0.25rem;
    min-height: 0; // flex 子项允许正确滚动
  }

  .toCreateBtnWrap {
    flex-shrink: 0;
    padding: 0.208rem 0;
  }

  .toCreateBtn {
    background-color: #28b8c3;
    color: #fff;
    padding: 0.208rem;
    border-radius: 0.083rem;
    text-align: center;
    margin: 0;
    cursor: pointer;
  }
}
</style>
